// extracted by mini-css-extract-plugin
module.exports = {"requirement":"Settlement_requirement__sgRv5","container":"Settlement_container__hnh6V","item":"Settlement_item__VTdkE","item__icon":"Settlement_item__icon__3uz6u"};